<template>
  <div id="details">
    <div class="details-title">
      <div class="tilte-left">
        <div class="tilte-h">{{ explain.name }}</div>
        <div class="title-address">
          <i></i>
          {{ explain.address }}
        </div>
      </div>
      <img src="../../../assets/enterprise/details.png" alt="" />
    </div>
    <div class="explain">
      <div class="explain-h">职能说明</div>
      <div class="explain-text">
        {{ explain.function }}
      </div>
    </div>
    <div class="details-phone">
      <div class="phone-h">科室联系方式</div>
      <ul>
        <li class="table-title">
          <div class="phone-left">业务科室</div>
          <div class="phone-right">联系方式</div>
        </li>
        <li>
          <van-collapse v-model="activeNames" accordion class="phone-left">
            <van-collapse-item
              v-for="(item, index) in explain.clerkList"
              :key="index"
              :name="index + ''"
              class="border-item"
            >
              <template #title>
                <div class="collapse-title">
                  <div class="phone-left">{{ item.name }}</div>
                  <a
                    class="phone-right"
                    :href="'tel:' + item.tel"
                    @click="buriedPoint"
                    >{{ item.tel }}</a
                  >
                  <div
                    class="explain-fun"
                    @click.stop="
                      explainFun(item.function, item.clerkName, item.address)
                    "
                  >
                    科室说明
                  </div>
                </div>
              </template>
              <!-- 内容 -->
              <div class="ul-children">
                <div
                  v-show="item.entEasyQueries && item.entEasyQueries.length > 0"
                  class="li-children"
                  v-for="(i, x) in item.entEasyQueries"
                  :key="x"
                >
                  <span>联系人：{{ i.branchName }}</span>
                  <a class="children-right" :href="'tel:' + i.branchPhone">{{
                    i.branchPhone
                  }}</a>
                </div>
                <div
                  v-show="item.entEasyQueries && item.entEasyQueries.length < 0"
                  class="li-children"
                >
                  <span>暂无数据</span>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </li>
      </ul>
    </div>
    <van-popup class="popup-list" v-model="isExplain">
      <!-- <div>{{ explainName }} 科室说明</div> -->
      <div>科室说明</div>
      <div class="popup-content" v-if="is_popup">
        <div class="popup-title">
          科室地址
        </div>
        <span>{{ popupAddress }}</span>
        <div class="popup-title">
          职能说明
        </div>
        <div class="popup-text">
          {{ poputConter }}
        </div>
      </div>
      <van-button round type="info" @click="isPopup">确定</van-button>
    </van-popup>
  </div>
</template>
<script>
// import { enterpriseDetails } from '@api/lishui'
import { listAllClerk } from '@api/lishui'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  name: 'Details',
  props: {},
  data() {
    return {
      explain: {},
      isExplain: false,
      is_popup: false,
      poputConter: '',
      activeNames: 1,
      explainName: '',
      popupAddress: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  created() {},
  mounted() {
    this.departmentDetail()
  },
  watch: {},
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    departmentDetail() {
      listAllClerk({
        departId: this.$route.query.id
      }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.explain = res.data
          if (this.explain.clerkList && this.explain.clerkList.length > 0) {
            this.explain.clerkList.map((val, index) => {
              val.entEasyQueries = [
                {
                  branchName: val.clerkName,
                  branchPhone: val.clerkTel
                }
              ]
            })
          }
        }
      })
    },
    explainFun(e, name, address) {
      this.buriedPoint()
      this.explainName = name
      this.is_popup = true
      this.isExplain = true
      this.poputConter = e
      this.popupAddress = address
    },
    isPopup() {
      this.isExplain = false
      setTimeout(() => {
        this.is_popup = false
      }, 500)
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#details {
  height: 100%;
  background-color: #fff;
  padding: 0 20px 20px;
  .details-title {
    padding: 22px 0 20px;
    border-bottom: 1px solid #e6e6e6;
    overflow: hidden;
    .tilte-left {
      float: left;
      margin-top: 22px;
      .tilte-h {
        font-size: 18px;
        font-weight: bold;
      }
      .title-address {
        font-size: 16px;
        margin-top: 9px;
        color: rgba(0, 0, 0, 0.55);
        i {
          display: inline-block;
          width: 10px;
          height: 16px;
          margin-top: 2px;
          background: url(../../../assets/enterprise/address.png) no-repeat;
          background-size: 100%;
          vertical-align: top;
          margin-right: 6px;
        }
      }
    }
    img {
      height: 80px;
      width: 85px;
      float: right;
    }
  }
  .explain {
    padding: 20px 0 25px;
    .explain-h {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
    }
    .explain-text {
      margin-top: 12px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.55);
    }
  }
  .details-phone {
    .phone-h {
      font-size: 16px;
      color: #000;
    }
    ul {
      margin-top: 11px;
      li {
        font-size: 14px;
        display: flex;
        line-height: 36px;
        color: rgba(0, 0, 0, 0.65);
        .phone-left {
          flex: 2;
          width: 20px;
          // overflow: hidden; //超出的文本隐藏
          // text-overflow: ellipsis; //溢出用省略号显示
          // white-space: wrap;
          // word-wrap : break-word;
          // display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
          // -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          // -webkit-line-clamp: 2; //规定行数
          font-size: 15px;
        }
        .phone-right {
          flex: 2;
          text-align: center;
          color: #0091ff;
          font-size: 15px;
        }
        .collapse-title {
          display: flex;
          font-size: 15px;

          .phone-left {
            padding-left: 12px;
            flex: 2;
            // overflow: hidden; //超出的文本隐藏
            // text-overflow: ellipsis; //溢出用省略号显示
            // white-space: nowrap;
          }
          .phone-right {
            position: relative;
            z-index: 100;
            flex: 2;
            text-align: center;
            color: #0091ff;
          }
          .explain-fun {
            position: relative;
            z-index: 100;
            // flex: 1;
            color: #0091ff;
          }
        }
        .ul-children {
          background-color: rgba(246, 247, 250, 1);
          font-size: 15px;
          padding-left: 15px;
          .li-children {
            height: 30px;
            line-height: 30px;
            display: flex;
            color: #333;
            span {
              margin-left: 13px;
              // flex: 1;
            }
            .children-right {
              flex: 2;
              text-align: left;
              color: #0091ff;
              margin-left: 40px;
            }
          }
        }
      }
      .table-title {
        border-bottom: none;
        background-color: rgba(243, 243, 243, 1);
        padding: 0 20px;
        .phone-left {
          flex: 1.75;
        }
        .phone-right {
          flex: 2;
          text-align: left;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  /deep/.van-cell__right-icon {
    position: absolute;
    left: 5px;
  }
  /deep/.van-collapse-item__content {
    padding: 0;
  }

  .popup-list {
    width: 55%;
    text-align: center;
    font-size: 16px;
    padding: 20px;
    border-radius: 6px;
    .popup-content {
      max-height: 250px;
      overflow: hidden;
      overflow-y: scroll;
      margin: 15px auto;
      text-align: left;
      line-height: 19px;
      font-size: 14px;
      letter-spacing: 1px;
      span {
        display: inline-block;
        margin-bottom: 10px;
      }
      .popup-text {
        width: 99%;
      }
      .popup-title {
        position: relative;
        padding-left: 10px;
        margin-bottom: 10px;
      }
      .popup-title::after {
        content: '';
        width: 5px;
        height: 13px;
        background-color: #3399ff;
        border-radius: 10px;
        position: absolute;
        left: 0;
        top: 2px;
      }
    }
    /deep/.van-button--info {
      width: 80%;
      height: 40px;
      opacity: 0.9;
    }
  }
}
/deep/.van-collapse-item__content {
  padding: 0 16px;
}
/deep/.van-cell {
  font-size: 16px;
}
</style>
